import {
    THANA_LIST_PARTNER_SUCCESS,
    THANA_LIST_PARTNER_FAILED,
    RESET_THANA_LIST_PARTNER,
    LOADING_THANA_LIST_PARTNER,
    NETWORK_ERROR_THANA_LIST_PARTNER
} from "../types/index";
import { partnerServices } from "../../config/axios";

const resetthanaListPartner = () => {
    return { type: RESET_THANA_LIST_PARTNER };
};

const thanaListPartner = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_THANA_LIST_PARTNER });
    await partnerServices
        .post("thanaListPartner", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "Success":
                    dispatch({ type: THANA_LIST_PARTNER_SUCCESS, payload: res.data });
                    break;
                default:
                    dispatch({ type: THANA_LIST_PARTNER_FAILED, payload: res.data });
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_THANA_LIST_PARTNER,
                payload: err
            });
        });
};

export { resetthanaListPartner, thanaListPartner };
